import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Components/Layout/Layout";
import Chatbot from "./Components/chatbot/Chatbot";

function App() {
  const [settings, setSettings] = useState("");
  const clientWebchatContainer =
    document.getElementsByTagName("chat-bot")[0] || "";
  const platformId = clientWebchatContainer
    ? clientWebchatContainer.getAttribute("platform_id")
    : "";
  const user_id = clientWebchatContainer
    ? clientWebchatContainer.getAttribute("user_id")
    : "";
  const chatbot_id = clientWebchatContainer
    ? clientWebchatContainer.getAttribute("chatbot_id")
    : "";
  useEffect(() => {
    configurations();
  }, []);

  async function configurations() {
    if (!chatbot_id) {
      return;
    }
    try {
      const url = `${process.env.REACT_APP_API_BACKEND_URL}/api/website-agents/agent-details/${chatbot_id}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data?.data) {
          setSettings(data.data);
        }
      }
    } catch (error) {
      console.log("Config fetch failed, showing bot with defaults", error);
    }
  }

  return (
    <div>
      <div className="App">
        {/* <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Chatbot />} />
            </Route>
          </Routes>
        </Router> */}
        <Chatbot
          settings={settings}
          platformId={platformId}
          user_id={user_id}
          chatbot_id={chatbot_id}
        />
      </div>
    </div>
  );
}

export default App;
